import { Crown, ShieldCheck, Users, Settings2, ArrowDown } from "lucide-react";
import { TIER_LEVEL, TIER_NAME, tierKey } from "@/pages/admin/adminSections";

const ROWS = [
  { k: "owner", Icon: Crown, color: "text-amber-300", desc: "Full access · can act on any admin · final say" },
  { k: "safety_admin", Icon: ShieldCheck, color: "text-violet-300", desc: "Moderation & safety tools" },
  { k: "admin", Icon: Users, color: "text-sky-300", desc: "Content & community management" },
  { k: "technical_admin", Icon: Settings2, color: "text-emerald-300", desc: "Diagnostics, health, logs · limited moderation" },
];

export default function PermissionFlowCard({ user }) {
  const mine = tierKey(user);
  return (
    <div className="card-surface p-4" data-testid="permission-flow-card">
      <div className="text-[10px] uppercase tracking-widest text-zinc-500 mb-3">Permission flow</div>
      <ol className="space-y-1">
        {ROWS.map(({ k, Icon, color, desc }, i) => (
          <li key={k} data-testid={`permission-tier-${k}`} className={`relative px-3 py-2 border ${mine === k ? "border-rose-500/50 bg-rose-500/10" : "border-white/5 bg-black/20"}`}>
            <div className="flex items-center gap-2 text-sm">
              <Icon size={14} className={color} />
              <span className="font-semibold">{TIER_NAME[k]}</span>
              <span className="text-xs text-zinc-500">Level {TIER_LEVEL[k]}</span>
              {mine === k && <span className="ml-auto text-[9px] uppercase tracking-widest text-rose-300">you</span>}
            </div>
            <div className="text-[11px] text-zinc-500 mt-0.5 pl-6">{desc}</div>
            {i < ROWS.length - 1 && <ArrowDown size={10} className="absolute -bottom-2 left-4 text-zinc-700" />}
          </li>
        ))}
      </ol>
      <p className="text-[11px] text-zinc-500 mt-3 leading-relaxed">
        Higher levels include all lower-level permissions. The Owner can override any action or restriction; every privileged action is logged in Audit Logs.
      </p>
    </div>
  );
}
